import React, { useEffect } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";

import RenderFields from "Components/RenderFields";
import { onlyNumberKeys } from "utils";

export const inputFields = [
  {
    label: "Line CT ratio",
    name: "lineCTRatio",
    placeholder: "Enter line CT ratio",
    isRequired: true,
    validationSchema: Yup.string()
      .required("Line CT ratio is required")
      .matches(/^\d+[/]\d+$/, "Enter valid ratio"),
  },
  {
    label: "Line PT ratio",
    name: "linePTRatio",
    placeholder: "Enter line PT ratio",
    isRequired: true,
    validationSchema: Yup.string()
      .required("Line CT ratio is required")
      .matches(/^\d+[/]\d+$/, "Enter valid ratio"),
  },
  {
    label: "Final MF",
    name: "finalMF",
    placeholder: "Enter final MF",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
    isRequired: true,
    disabled: true,
  },
  { header: "Line CT Serial No:" },
  {
    label: "R-Phase",
    name: "rPhase",
    placeholder: "Enter R-Phase",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e),
  },
  {
    label: "Y-Phase",
    name: "yPhase",
    placeholder: "Enter Y-Phase",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e),
  },
  {
    label: "B-Phase",
    name: "bPhase",
    placeholder: "Enter B-Phase",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e),
  },
];

const getRatioValue = (value) => {
  const values = value.split("/");
  return +values[0] / +values[1];
};

const ServiceConnectionDetails = ({ formik }) => {
  const {
    values: {
      meter: { meterCTR, meterPTR, dialMF },
      serviceConnection: { lineCTRatio, linePTRatio },
    },
    setFieldValue,
  } = formik;

  useEffect(() => {
    if (meterCTR && meterPTR && lineCTRatio && linePTRatio) {
      const meterCTRValue = getRatioValue(meterCTR);
      const linePTRValue = getRatioValue(linePTRatio);
      const meterPTRValue = getRatioValue(meterPTR);
      const lineCTRValue = getRatioValue(lineCTRatio);
      const finalMF = (
        (lineCTRValue / meterCTRValue) *
        (linePTRValue / meterPTRValue) *
        dialMF
      ).toFixed(2);
      setFieldValue("serviceConnection.finalMF", +finalMF);
    }
  }, [meterCTR, meterPTR, lineCTRatio, linePTRatio, dialMF]);

  return (
    <RenderFields
      formik={formik}
      inputFields={inputFields}
      parentKey="serviceConnection"
    />
  );
};

ServiceConnectionDetails.propTypes = {
  formik: PropTypes.object,
};

export default ServiceConnectionDetails;
